import React, { FC } from 'react';
import styled from 'styled-components';

/* import { SpaceProps } from 'ui/components/Space'; */

import { InlineBody } from './styled';

export const BottomWrapper = styled.div`
  position: fixed;
  bottom: 45px;
  right: 44px;
  left: 244px;
  z-index: 300;
  display: flex;
  justify-content: center;
`;

const Bottom: FC<SpaceProps> = ({ children, ...props }) => {
  return (
    <BottomWrapper>
      <InlineBody {...props}>{children}</InlineBody>
    </BottomWrapper>
  );
};

export default Bottom;
